import type { LucideIcon } from "lucide-react"

export interface KpiData {
  value: number
  subtitle?: string
  subtitleColor?: string
}

export interface KpiDefinition {
  id: string
  label: string
  icon: LucideIcon
  fetchData: () => Promise<KpiData>
  linkTo: string
  colorAccent: string
  isPlugin?: boolean
  order?: number
  moduleName?: string
}

const registry = new Map<string, KpiDefinition>()

export function registerKpi(definition: KpiDefinition): void {
  registry.set(definition.id, definition)
}

export function unregisterKpi(id: string): void {
  registry.delete(id)
}

export function getAllKpis(): KpiDefinition[] {
  return Array.from(registry.values()).sort(
    (a, b) => (a.order ?? 100) - (b.order ?? 100)
  )
}
